import { render, staticRenderFns } from "./Detailppb.vue?vue&type=template&id=5b46100a&scoped=true"
import script from "./Detailppb.vue?vue&type=script&lang=js"
export * from "./Detailppb.vue?vue&type=script&lang=js"
import style0 from "./Detailppb.vue?vue&type=style&index=0&id=5b46100a&prod&lang=scss"
import style1 from "./Detailppb.vue?vue&type=style&index=1&id=5b46100a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b46100a",
  null
  
)

export default component.exports